import { notificationService } from './notificationService'

/**
 * The notification module façade. No store: the list belongs to whichever page is showing it, and
 * the one piece of shared notification state — the unread count in the header — already lives in the
 * ui store, written by `BaseApp`'s poll.
 */
export const useNotification = () => {
  return {
    notification: {
      service: notificationService()
    }
  }
}
